/* import __COLOCATED_TEMPLATE__ from './header-card.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Component from '@glimmer/component';
import { type ExpiredSubscriptionBotTarget } from '../expired-subscription';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type ExpiredSubscriptionService from 'embercom/services/expired-subscription-service';
import { type ExpiredSubscriptionAnalyticsObject } from 'embercom/services/expired-subscription-service';

export enum ExpirationReason {
  FinStandaloneSalesLed = 'fin-standalone-sales-led',
  FinStandaloneSelfServe = 'fin-standalone-self-serve',
  ActiveEarlyStageApplication = 'active-early-stage-application',
  FreeTrialEnded = 'free-trial-ended',
  SubscriptionCancelled = 'subscription-cancelled',
  NonPaymentSelfServe = 'non-payment-self-serve',
  NonPaymentSalesLed = 'non-payment-sales-led',
  NewWorkspace = 'new-workspace',
}

export interface Args {
  heading: string;
  body: string;
  buttons: HeaderCardButton[];
}

export interface HeaderCardButton {
  type: 'primary' | 'secondary';
  label: string;
  action: () => void;
  dataIntercomBotTarget?: ExpiredSubscriptionBotTarget;
  analyticsObject: ExpiredSubscriptionAnalyticsObject;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
  Blocks: any;
}

export default class HeaderCard extends Component<Signature> {
  @service declare purchaseAnalyticsService: $TSFixMe;
  @service declare expiredSubscriptionService: ExpiredSubscriptionService;

  @action
  handleButtonClick(button: HeaderCardButton) {
    this.expiredSubscriptionService.sendAnalyticsEvent({
      place: 'expired_subscription_page_header_card',
      object: button.analyticsObject,
      extra: this.buttonAnalyticsExtra(button),
    });
    button.action();
  }

  private buttonAnalyticsExtra(button: HeaderCardButton) {
    return button.dataIntercomBotTarget
      ? { data_intercom_bot_target: button.dataIntercomBotTarget }
      : {};
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ExpiredSubscription::Header::HeaderCard': typeof HeaderCard;
    'expired-subscription/header/header-card': typeof HeaderCard;
  }
}
